import React, { useEffect } from 'react';
import Layout from '../../../components/Layout';
import {Link} from "react-router-dom";
import {EditIcon, DownloadIcon, UploadIcon, ArrowBottom} from "../../../assets/icons/Icons";
import SearchFilter from "../../../components/filters/SearchFilter";
import { FilterContextProvider } from "../../../contexts/FilterContext";
import EditShippingAddress from "../../../components/shipping-addresses/Edit";
import CreateShippingAddressForm from "../../../components/shipping-addresses/Create";
import Chip from "../../../components/Chip";
import MessagePopup from "../../../components/MessagePopup";
import DataTable from "../../../components/DataTable";
import useData from "../../../hooks/useData";
import useExportCSV from "../../../hooks/useExportCSV";
import FilterShippingAddresses from "../../../api/shipping-addresses/filterShippingAddresses";
import DateRangeFilter from "../../../components/filters/DateRangeFilter";
import ResetFilters from "../../../components/filters/ResetFilters";
import OfficesFilter from "../../../components/filters/OfficesFilter";
import ShippingAddressFilter from "../../../components/filters/ShippingAddressFilter";
import {formatDate} from "../../../utils/formatDate";
import {useTranslation} from "react-i18next";
import CustomTooltip from "../../../components/CustomTooltip";
import { useGlobalContext } from '../../../contexts/GlobalContext';

function Index(props) {

    const { t } = useTranslation();

    const {
        data,
        errorMessage,
        loadingData,
        pageCount,
        newItemAdded,
        setNewItemAdded,
        itemUpdated,
        setItemUpdated,
        selectedItem,
        setSelectedItem,
        showEditItem,
        setShowEditItem,
        showCreateItem,
        setShowCreateItem
    } = useData(FilterShippingAddresses);

        const { setPageTitle, setBreadcrumbs } = useGlobalContext();
          
        useEffect(() => {
            setPageTitle(t("Offices"));
            setBreadcrumbs([t("Offices"), t("Shipping Addresses")]);
          
            return () => {
              setPageTitle("");
              setBreadcrumbs([]);
            };
              // eslint-disable-next-line
        }, []);

    const { handleExportCSV } = useExportCSV(FilterShippingAddresses, 'shipping_addresses');

    const handleEditClick = (e, item) => {
        e.preventDefault();
        setSelectedItem(item);
        setShowEditItem(true);
    };

    return (
        <Layout title={t("Shipping Address")} breadcrumbs={t("Offices")}>

            {showEditItem && <EditShippingAddress shippingAddress={selectedItem} onClose={() => setShowEditItem(false)} onUpdate={e => {setShowEditItem(false); setItemUpdated(true); }} />}
            {itemUpdated && <MessagePopup title="Shipping Address Updated!" message="The Shipping Address has been successfully updated!" onClose={e => setItemUpdated(false)}/>}
            {showCreateItem && <CreateShippingAddressForm onClose={() => setShowCreateItem(false)} onCreate={e => {setShowCreateItem(false); setNewItemAdded(true); }} />}
            {newItemAdded && <MessagePopup title="Shipping Address Created!" message="The Shipping Address has been successfully created!" onClose={e => setNewItemAdded(false)}/>}

            <DataTable
                filtersTop={<>
                    <FilterContextProvider name="s">
                        <SearchFilter/>
                    </FilterContextProvider>
                </>}
                filtersBottom={<>
                    <FilterContextProvider name="office_ids">
                        <OfficesFilter/>
                    </FilterContextProvider>
                    <FilterContextProvider name="date">
                        <DateRangeFilter/>
                    </FilterContextProvider>
                    <FilterContextProvider>
                        <ResetFilters/>
                    </FilterContextProvider>
                </>}
                buttons={<>
                    <button onClick={handleExportCSV} className="btn btn-secondary btn-medium">
                        <DownloadIcon/>
                        {t('Export CSV')}
                    </button>
                    <button className="btn btn-primary btn-medium" onClick={e => setShowCreateItem(true)}>
                        {t('Create')}
                    </button>
                </>}
                columns={[
                    {header: t("Shipping ID"), accessor: "id"},
                    {header: t("Address"), accessor: "address1"},
                    {header: t("Attention Text"), accessor: "first_name"},
                    {header: t("Created by"), accessor: "created_by"},
                    {header: t("Created"), accessor: "created_at"},
                    {header: t("Status"), accessor: "is_active"},
                    {header: t("Action"), accessor: "actions"}
                ]}
                rows={data.data || []}
                pageCount={pageCount}
                loadingData={loadingData}
                error={errorMessage}
                actions={(item) => (
                        <Link to="#" onClick={(e) => handleEditClick(e, item)}>
                            <CustomTooltip icon={<EditIcon/>} message= {t("Edit")}/>
                        </Link>
                )}
                customOutputs={(columnName, value, row) => {
                    switch (columnName){
                        case 'is_active' :
                            let status = 'inactive';
                            if(value){
                                status = 'active';
                            }
                            return <Chip state={status} label={status.charAt(0).toUpperCase() + status.slice(1)} showAsTooltop/>
                        case 'address1':
                            return `${row.address1}, ${row.state}`;
                        case 'first_name':
                            return `${row.first_name} ${row.last_name}`;
                        case 'created_at' :
                            return formatDate(value)
                        default:
                            return value
                    }
                }}
            />

        </Layout>
    );
}

export default Index;